import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, Inject, PLATFORM_ID, ChangeDetectionStrategy } from "@angular/core";
import { environment } from "app/environments/environment";

@Component({
  selector: "app-no-access",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./no-access.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./no-access.component.scss",
})
export class NoAccessComponent {
  readonly partnerPortalUrl = environment.partnerPortalUrl;
  private readonly fallbackLocale = "en-GB";
  private readonly browserLocale: string;
  private isGerman: boolean = true;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {
    this.browserLocale = this.resolveBrowserLocale();
    if (this.browserLocale === "de" || this.browserLocale.startsWith("de")) {
      this.isGerman = true;
    } else {
      this.isGerman = false;
    }
  }

  private resolveBrowserLocale(): string {
    if (!isPlatformBrowser(this.platformId)) {
      return this.fallbackLocale;
    }

    const locales = [...(navigator.languages[0] ?? []), navigator.language];
    const preferredGermanLocale = locales.find((lang) =>
      lang?.toLowerCase().startsWith("de"),
    );

    return preferredGermanLocale ?? navigator.language ?? this.fallbackLocale;
  }

  get title(): string {
    return this.isGerman
      ? "Keine Berechtigung auf das TESVOLT Portal"
      : "No access to the TESVOLT portal";
  }

  get description(): string {
    return this.isGerman
      ? "Leider haben Sie aktuell keine Berechtigung zur Nutzung des TESVOLT Portals. Wenn Sie eine Inbetriebnahme eines TESVOLT Speichers durchführen oder planen, dann melden Sie sich bitte umgehend beim TESVOLT Service. Wir geben Ihnen schnellstmöglich den benötigten Zugriff. E-Mail-Adresse: service@tesvolt.com"
      : "Unfortunately, you do not currently have permission to use the TESVOLT portal. If you are commissioning or planning to commission a TESVOLT storage system, please contact TESVOLT Service immediately. We will grant you the necessary access as soon as possible. Email address: service@tesvolt.com";
  }

  get cta(): string {
    return this.isGerman ? "Zum Partner Portal" : "To the Partner Portal";
  }
}
